import { isDefined } from "@perxis-auto/shared";
import { flattenFilterGridItems } from "../../../../shared/store/config/lib/flattenFilterGridItems.js";
import { getDependentFilterKeysByKey } from "./getDependentFilterKeysByKey.js";
const getDependantFiltersToReset = (key, grid, filterChoice) => {
  const filterGridItems = flattenFilterGridItems(grid);
  const filtersToReset = getDependentFilterKeysByKey(key, filterGridItems);
  const uniqueFiltersSet = new Set(filtersToReset);
  const uniqueFilters = Array.from(uniqueFiltersSet.values());
  const nonEmptyFiltersToReset = uniqueFilters.filter((filterKey) => isDefined(filterChoice[filterKey]));
  return nonEmptyFiltersToReset;
};
export {
  getDependantFiltersToReset
};
